import { Component } from '@angular/core';

@Component({
  selector: 'via-period-range',
  templateUrl: './period-range.component.html',
  styleUrls: ['./period-range.component.scss']
})
export class PeriodRangeComponent {

  public selectedPeriodRanges = 'weekly';
  public periodRanges = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'yearly', label: 'Yearly' },
  ];
}
